import { useEffect } from 'react';

const DEFAULT_SELECTOR = [
  'main .card',
  'main .rounded-xl',
  'main .rounded-2xl',
  'main .rounded-3xl',
  'main [data-reveal]'
].join(', ');

export default function useNaturalScrollReveal(selector = DEFAULT_SELECTOR) {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return undefined;

    const observer = new IntersectionObserver(
      (entries) => {
        // Find how many actually intersected this frame
        const newlyIntersecting = entries.filter(e => e.isIntersecting);
        
        newlyIntersecting.forEach((entry, index) => {
          // Stagger effect for items entering at the same time
          setTimeout(() => {
            if (entry.target) {
              entry.target.classList.add('is-revealed');
            }
          }, index * 75); // 75ms stagger delay
        });
        
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            entry.target.classList.remove('is-revealed');
          }
        });
      },
      {
        threshold: 0.15,
        rootMargin: '0px 0px -5% 0px',
      }
    );

    const observed = new Set();

    const registerTargets = () => {
      const targets = document.querySelectorAll(selector);
      targets.forEach((target) => {
        if (observed.has(target)) return;
        target.classList.add('natural-reveal-target');
        observer.observe(target);
        observed.add(target);
      });
    };

    registerTargets();

    const mutationObserver = new MutationObserver(() => {
      registerTargets();
    });

    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => {
      mutationObserver.disconnect();
      observer.disconnect();
      observed.clear();
    };
  }, [selector]);
}
